import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import {
  getGradingCriteria,
  createGradingCriterion,
  deleteGradingCriterion,
  setDefaultGradingCriterion,
  updateGradingCriterion,
  getGradingCriterion,
} from "../Api/gradingCriteria";
import {
  CreateGradingCriterion,
  GradingCriterion,
  UpdateGradingCriterion,
} from "../Models/gradingCriteria";

export const useGradingCriteria = () => {
  return useQuery({
    queryKey: ["gradingCriteria"],
    queryFn: getGradingCriteria,
  });
};

export const useGradingCriterion = (id: number) => {
  return useQuery<GradingCriterion>({
    queryKey: ["gradingCriterion", id],
    queryFn: () => getGradingCriterion(id),
    enabled: !!id,
  });
};

export const useCreateGradingCriterion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateGradingCriterion) =>
      createGradingCriterion(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["gradingCriteria"] });
    },
  });
};

export const useDeleteGradingCriterion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteGradingCriterion(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["gradingCriteria"] });
    },
  });
};

export const useUpdateGradingCriterion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: number;
      payload: UpdateGradingCriterion;
    }) => updateGradingCriterion(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["gradingCriteria"] });
    },
  });
};

export const useSetDefaultGradingCriterion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => setDefaultGradingCriterion(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["gradingCriteria"] });
    },
  });
};
